import classNames from 'classnames';
import { MEDIA_QUERY_MOBILE_DOWN } from 'utils/constants/breakpoints';
import * as styles from './styles/styles.module.scss';

type Images = {
  mobile: {
    avif: string;
    webp: string;
    png: string;
  };
  desktop: {
    avif: string;
    webp: string;
    png: string;
  };
};

type PlusFeatureCarouselProps = {
  title: string;
  description: string;
  altText: string;
  images: Images;
  isMiddleSlide?: boolean;
  isLeftSlide?: boolean;
  isRightSlide?: boolean;
};

const PlusFeatureCarousel = ({ title, description, isLeftSlide, isMiddleSlide, isRightSlide, images, altText }: PlusFeatureCarouselProps) => {
  const { mobile, desktop } = images;

  return (
    <div className={styles.slideContainer}>
      <div
        className={classNames({
          [styles.leftSlide]: isLeftSlide,
          [styles.middleSlide]: isMiddleSlide,
          [styles.rightSlide]: isRightSlide,
          [styles.slideInnerContainer]: true
        })}
      >
        <div className={styles.imageContainer}>
          <picture>
            <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={mobile.avif} type="image/avif" />
            <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={mobile.webp} type="image/webp" />
            <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={mobile.png} type="image/png" />
            <source srcSet={desktop.avif} type="image/avif" />
            <source srcSet={desktop.webp} type="image/webp" />
            <img src={desktop.png} alt={altText} className={styles.image} loading="lazy" />
          </picture>
        </div>
        <div className={styles.descriptionContainer}>
          <h3 className={styles.descriptionTitle}>{title}</h3>
          <p className={styles.descriptionBody}>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default PlusFeatureCarousel;
